// extracted by mini-css-extract-plugin
export var deleteModal = "_q3-0";